import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  updateDoc,
  orderBy,
  startAfter,
  getCountFromServer,
  where,
  documentId,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "surveys", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getSurveys = async (last, filters = {}) => {
  const orderByField = filters?.order?.orderBy || "createdAt";
  const orderDirection = filters?.order?.direction || "desc";
  try {
    // Build the base query
    let q = query(
      collection(db, "surveys"),
      orderBy(orderByField, orderDirection),
      ...(last ? [startAfter(last)] : []),
      limit(10),
    );

    // Conditionally add filter categories
    if (!!filters.categories?.length) {
      q = query(
        q,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    // Conditionally add filter finished
    if (!!filters.finished) {
      q = query(q, where("type", "==", "finished"));
    }

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const surveys = documentSnapshots.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    // Build the query for the total count
    let queryCount = query(collection(db, "surveys"));

    if (!!filters.categories?.length) {
      queryCount = query(
        queryCount,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    if (!!filters.finished) {
      queryCount = query(queryCount, where("type", "==", "finished"));
    }

    const countSnapshot = await getCountFromServer(queryCount);
    const totalSurveysCount = countSnapshot.data().count;

    // Return surveys, last document, and total count of surveys
    return { surveys, last: lastVisible, totalSurveysCount };
  } catch (error) {
    console.error(`Error while getting surveys: ${error}`);
    return error;
  }
};

export const getSurveyById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const survey = docSnap.data();
  return docSnap.exists
    ? { id: docSnap.id, ...survey, category: [], reviewers: [] }
    : null;
};

export const updateSurveys = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating survey ${e}`);
    return false;
  }
};

export const getSurveysByIds = async (ids) => {
  const q = query(collection(db, "surveys"), where(documentId(), "in", ids));
  const querySnapshot = await getDocs(q);
  const predictions = querySnapshot.docs.map((doc) => {
    return { ...doc.data(), id: doc.id };
  });
  return predictions;
};
